import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@zvoove-market/shared';

export interface RoleGuardOptions {
  mandantRoles?: string[];
  customerRoles?: string[];
  globalRoles?: string[];
  condition: 'all' | 'any';
  redirectUrl?: string;
}
export const roleGuard =
  (options: RoleGuardOptions): CanActivateFn =>
  (): true | UrlTree => {
    if (!options.mandantRoles?.length && !options.customerRoles?.length && !options.globalRoles?.length) {
      return true;
    }
    const ctx = inject(AuthService).$context();
    const globalRolesOk = checkRoles(ctx.globalRoles, options.globalRoles, options.condition);
    const customerRolesOk = checkRoles(ctx.customer?.roles || [], options.customerRoles, options.condition);
    const mandantRolesOk = checkRoles(ctx.mandant?.roles || [], options.mandantRoles, options.condition);
    const isOk =
      options.condition == 'all' ? globalRolesOk && customerRolesOk && mandantRolesOk : globalRolesOk || customerRolesOk || mandantRolesOk;
    return isOk ? true : inject(Router).parseUrl(options.redirectUrl ?? '/page-not-found');
  };

function checkRoles(userRoles: string[], neededRoles: string[] | undefined, condition: 'all' | 'any') {
  if (!neededRoles?.length) {
    // for 'any' you don't want to combine a true-because-empty with a false to a combined true result
    return condition == 'all' ? true : false;
  }
  const op = condition == 'all' ? Array.prototype.every : Array.prototype.some;
  const result = op.call(neededRoles, (role: string) => userRoles.includes(role));
  return result;
}
